/**
* Created For: 找回密码，或首次登录验证
* Author: chenLiYan.
* Date: 2018/11/29 0029 10:16.
*/
<template>
  <div class="reset-page">
    <v-title :title="title" :isShowBack="true"></v-title>
    <form class="form-wrap" autocomplete="off">
      <!--<label class="item-li flex-wrap">-->
      <!--<custom-input type="tel" v-model="params.mobile" :maxlength="11" placeholder="输入手机号"></custom-input>-->
      <!--<span class="sprite icon-close" v-if="params.mobile" @click="params.mobile=''"></span>-->
      <!--</label>-->
      <!--<div class="item-li flex-wrap">-->
      <!--<input class="sms-code" v-model.trim="params.smsCode" type="text" :maxlength="6" placeholder="输入验证码"/>-->
      <!--<button type="button" :class="['get-code',isCoding ? 'coding':'']" @click="getCodeHandle()">{{ codeBtnText }}</button>-->
      <!--</div>-->
      <label class="item-li flex-wrap">
        <input v-model.trim="params.newPassword" type="text" :maxlength="20" placeholder="输入新密码（6-20）"/>
      </label>
      <label class="item-li sure-password flex-wrap">
        <input v-model.trim="reNewPassword" type="text" :maxlength="20" placeholder="确认新密码"/>
      </label>
      <button type="button" :class="['submit-btn',isValid ? 'valid' :'']" @click="submitHandle()">完成</button>
    </form>
    <custom-loading v-if="loading"></custom-loading>
  </div>
</template>

<script>
import {
  asyncActivateUser,
  asyncResetPwd
} from '@/api/auth'
export default {
  name: 'ResetPassword',
  props: {},
  data () {
    return {
      loading: false,
      title: this.$route.query.activated ? '首次登录验证' : '重置密码',
      params: {
        // mobile:this.$store.state.user.localUserName,
        // smsCode:'',
        username: this.$route.query.username,
        oldPassword: this.$route.query.password,
        factoryKey: 'yabao',
        newPassword: ''
      },
      reNewPassword: '',
      isCoding: false, // 是否正在获取验证码
      codeBtnText: '获取验证码',
      timer: null
    }
  },
  computed: {
    // 是否数据全部输入
    isValid () {
      return !!(this.params.mobile && this.params.smsCode && this.params.newPassword && this.reNewPassword)
    }
  },
  beforeMount () {
    if (!this.$route.query.username) {
      this.$router.push({ name: 'login' })
    }
  },
  methods: {
    // 获取验证码点击事件
    //            getCodeHandle(){
    //                if(this.loading || this.isCoding){
    //                    return false
    //                }
    //                let message = "";
    //                if(!this.params.mobile){
    //                    message = "请输入手机号"
    //                }else if(!/^1([3-9])\d{9}$/.test(this.params.mobile)){
    //                    message = "手机号格式错误";
    //                }
    //                if(message) {
    //                    this.$createDialog({
    //                        title: "提示",
    //                        type: 'alert',
    //                        content: message,
    //                    }).show();
    //                }else{
    //                    this.isCoding = true;
    //                    this.countDown(60000);  // 倒计时
    //                    // 获取手机验证码
    //                    let smsCategory = this.$route.query.activated ? 'activate_user' :'reset_password';
    //                    asyncSmsCode(this.params.mobile,smsCategory).then(res=>{
    //                        if(res.code !== 1){
    //                            window.clearInterval(this.timer);
    //                            this.codeBtnText = "重新获取";
    //                            this.isCoding = false;
    //                        }
    //                    }).catch(()=>{
    //                        window.clearInterval(this.timer);
    //                        this.codeBtnText = "重新获取";
    //                        this.isCoding = false;
    //                    });
    //                }
    //            },
    // 点击确认
    submitHandle () {
      let message = ''
      //                if(!this.params.mobile){
      //                    message = "请输入手机号"
      //                }else if(!/^1([3-9])\d{9}$/.test(this.params.mobile)){
      //                    message = "手机号格式错误";
      //                }else if(!this.params.smsCode){
      //                    message = "请输入验证码";
      //                }
      if (!this.params.newPassword) {
        message = '请输入新密码'
      } else if (!/^.{6,20}$/.test(this.params.newPassword)) {
        message = '新密码长度6-20位'
      } else if (!this.reNewPassword) {
        message = '请确认新密码'
      } else if (this.reNewPassword !== this.params.newPassword) {
        message = '密码两次不一致'
      }
      if (message) {
        this.$createDialog({
          title: '提示',
          type: 'alert',
          content: message
        }).show()
      } else if (!this.loading) {
        this.loading = true
        if (this.$route.query.activated) {
          // 用户激活时
          asyncActivateUser(this.params).then(res => {
            this.loading = false
            if (res.code === 1) {
              this.$createDialog({
                title: '提示',
                type: 'alert',
                content: '首次登录验证成功！',
                onConfirm: () => {
                  // 触发登录
                  this.$store.dispatch('Login', {
                    username: this.params.mobile,
                    password: this.params.newPassword
                  }).then(res => {
                    if (res.code === 1) {
                      // 首次登录验证，完成后跳转到首页
                      this.$router.replace({ name: 'index' })
                    } else {
                      this.$router.go(-1)
                    }
                  }).catch(() => {
                    this.$router.go(-1)
                  })
                }
              }).show()
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          // 提交重置
          asyncResetPwd(this.params).then(res => {
            this.loading = false
            if (res.code === 1) {
              this.$createDialog({
                title: '提示',
                type: 'alert',
                content: '重置密码成功！',
                onConfirm: () => {
                  // 触发登录
                  this.$store.dispatch('Login', {
                    username: this.params.mobile,
                    password: this.params.newPassword
                  }).then(res => {
                    if (res.code === 1) {
                      // 找回密码，完成后跳转到首页
                      this.$router.replace({ name: 'index' })
                    } else {
                      this.$router.go(-1)
                    }
                  }).catch(() => {
                    this.$router.go(-1)
                  })
                }
              }).show()
            }
          }).catch(() => {
            this.loading = false
          })
        }
      }
    }
    // 倒计时
    //            countDown(left) {
    //                let curTime = new Date().getTime(),
    //                    preTime = new Date().getTime(),
    //                    self = this;
    //                window.clearInterval(self.timer);
    //                this.timer = setInterval(function () {    //开启定时器
    //                    let nowTime = new Date().getTime();
    //                    if (nowTime - preTime > 60000 || nowTime - preTime < 0) {   //防止修改本地时间后,重新请求数据，避免导致误差
    //                        window.clearInterval(self.timer);
    //                        self.countDown(preTime - curTime - 500);
    //                        return false;
    //                    }
    //                    preTime = nowTime;
    //                    if (left - (nowTime - curTime) > 0) {
    //                        let less = left - (nowTime - curTime);
    //                        let days = Math.floor(less / 864e5);  // 天
    //                        let hours = Math.floor((less - days * 864e5) / 36e5);   // 小时
    //                        let minutes = Math.floor((less - days * 864e5 - hours * 36e5) / 6e4); // 分钟
    //                        let seconds = Math.floor((less - days * 864e5 - hours * 36e5 - minutes * 6e4) / 1e3); // 秒
    //                        self.codeBtnText = seconds + "s"
    //                    } else {
    //                        window.clearInterval(self.timer);
    //                        self.codeBtnText = "重新获取";
    //                        self.isCoding = false
    //                    }
    //                }, 400);
    //            }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/sign/login.styl"
</style>
